module.exports = __webpack_public_path__ + "static/img/apple-app-store-icon.9f13c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-app-store-icon.png
// module id = Rj73
// module chunks = 1